document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".flappy-section");
  if (!section) return;

  const canvas = document.getElementById("flappyCanvas");
  const ctx = canvas.getContext("2d");

  const tutorialScreen = document.getElementById("tutorialScreen");
  const startScreen = document.getElementById("startScreen");
  const gameOverScreen = document.getElementById("gameOverScreen");
  const winScreen = document.getElementById("winScreen");

  const continueBtn = document.getElementById("continueBtn");
  const startBtn = document.getElementById("startBtn");
  const restartBtn = document.getElementById("restartBtn");
  const copyCodeBtn = document.getElementById("copyCodeBtn");

  const targetScoreEl = document.getElementById("targetScore");
  const promoCode = document.getElementById("promoCode");

  const birdUrl = section.dataset.bird;
  const pipeUrl = section.dataset.pipe;
  const bgUrl = section.dataset.bg;

  const rewardCode = section.dataset.code || "WIN10";
  const winScore = Number(section.dataset.winScore || 10);

  if (targetScoreEl) targetScoreEl.textContent = winScore;
  if (promoCode) promoCode.textContent = rewardCode;

  canvas.width = 450;
  canvas.height = 700;

  const birdImg = new Image();
  birdImg.src = birdUrl;

  const pipeImg = new Image();
  pipeImg.src = pipeUrl;

  const bgImg = new Image();
  bgImg.src = bgUrl;

  let bird;
  let pipes;
  let score;
  let frame;
  let running;
  let ended;

  function hideAllScreens() {
    tutorialScreen.classList.remove("is-active");
    startScreen.classList.remove("is-active");
    gameOverScreen.classList.remove("is-active");
    winScreen.classList.remove("is-active");
  }

  function resetGame() {
    bird = {
      x: 78,
      y: 285,
      w: 74,
      h: 58,
      velocity: 0,
      gravity: 0.42,
      lift: -8.6
    };

    pipes = [];
    score = 0;
    frame = 0;
    running = false;
    ended = false;

    if (copyCodeBtn) copyCodeBtn.textContent = "Copy Code";

    drawScene();
  }

  function startGame() {
    hideAllScreens();
    resetGame();
    running = true;
    ended = false;
    loop();
  }

  function jump() {
    if (!running || ended) return;
    bird.velocity = bird.lift;
  }

  function createPipe() {
    const gap = 190;
    const minTop = 70;
    const maxTop = 380;
    const top = Math.floor(Math.random() * (maxTop - minTop)) + minTop;

    pipes.push({
      x: canvas.width + 20,
      w: 82,
      top: top,
      bottom: top + gap,
      passed: false
    });
  }

  function drawBackground() {
    if (bgImg.complete) {
      ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);
    } else {
      ctx.fillStyle = "#0aa0c7";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
  }

  function drawPipes() {
    pipes.forEach(function (pipe) {
      const pipeHeight = 520;

      if (pipeImg.complete) {
        ctx.drawImage(pipeImg, pipe.x, pipe.bottom, pipe.w, pipeHeight);

        ctx.save();
        ctx.translate(pipe.x + pipe.w / 2, pipe.top);
        ctx.scale(1, -1);
        ctx.drawImage(pipeImg, -pipe.w / 2, 0, pipe.w, pipeHeight);
        ctx.restore();
      } else {
        ctx.fillStyle = "#76b63f";
        ctx.fillRect(pipe.x, pipe.bottom, pipe.w, pipeHeight);
        ctx.fillRect(pipe.x, pipe.top - pipeHeight, pipe.w, pipeHeight);
      }
    });
  }

  function drawBird() {
    if (birdImg.complete) {
      ctx.drawImage(birdImg, bird.x, bird.y, bird.w, bird.h);
    } else {
      ctx.fillStyle = "#fff";
      ctx.beginPath();
      ctx.arc(bird.x + 30, bird.y + 30, 25, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function drawScore() {
    ctx.fillStyle = "#ffffff";
    ctx.strokeStyle = "#111111";
    ctx.lineWidth = 5;
    ctx.font = "bold 38px Arial";
    ctx.textAlign = "center";

    ctx.strokeText(score, canvas.width / 2, 58);
    ctx.fillText(score, canvas.width / 2, 58);
  }

  function drawScene() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawBackground();
    drawPipes();
    drawBird();
    drawScore();
  }

  function updateBird() {
    bird.velocity += bird.gravity;
    bird.y += bird.velocity;

    if (bird.y < 0) {
      bird.y = 0;
      bird.velocity = 0;
    }

    if (bird.y + bird.h >= canvas.height) {
      endGame(false);
    }
  }

  function updatePipes() {
    frame++;

    if (frame % 105 === 0) {
      createPipe();
    }

    const speed = 2.45 + score * 0.05;

    pipes.forEach(function (pipe) {
      pipe.x -= speed;

      if (!pipe.passed && pipe.x + pipe.w < bird.x) {
        pipe.passed = true;
        score++;

        if (score >= winScore) {
          endGame(true);
        }
      }

      const birdLeft = bird.x + 12;
      const birdRight = bird.x + bird.w - 10;
      const birdTop = bird.y + 8;
      const birdBottom = bird.y + bird.h - 8;

      const hitX = birdRight > pipe.x && birdLeft < pipe.x + pipe.w;
      const hitY = birdTop < pipe.top || birdBottom > pipe.bottom;

      if (hitX && hitY) {
        endGame(false);
      }
    });

    pipes = pipes.filter(function (pipe) {
      return pipe.x + pipe.w > -30;
    });
  }

  function loop() {
    if (!running || ended) return;

    updateBird();
    updatePipes();
    drawScene();

    requestAnimationFrame(loop);
  }

  function endGame(won) {
    if (ended) return;

    running = false;
    ended = true;

    setTimeout(function () {
      if (won) {
        promoCode.textContent = rewardCode;
        winScreen.classList.add("is-active");
      } else {
        gameOverScreen.classList.add("is-active");
      }
    }, 220);
  }

  continueBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    hideAllScreens();
    startScreen.classList.add("is-active");
  });

  startBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    startGame();
  });

  restartBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    startGame();
  });

  copyCodeBtn.addEventListener("click", function (e) {
    e.stopPropagation();

    navigator.clipboard.writeText(rewardCode).then(function () {
      copyCodeBtn.textContent = "Copied!";
    });
  });

  canvas.addEventListener("click", jump);

  canvas.addEventListener("touchstart", function (e) {
    e.preventDefault();
    jump();
  });

  document.addEventListener("keydown", function (e) {
    if (e.code === "Space") {
      e.preventDefault();
      jump();
    }
  });

  resetGame();
});